import type {
  ConfigFormat,
  McpClientId,
} from "@arcadeai/ui-kit/mcp-gateway-connect";
import type { JSX } from "react";
import type { ConnectGatewayShape } from "@/app/onboarding-first-win/components/client-connect-detail-panel";
import { ClientConnectPicker } from "@/app/onboarding-first-win/components/client-connect-picker";

type ConnectSectionBodyProps = {
  clientForNav: McpClientId | undefined;
  enginePublicUrl: string;
  gateway: ConnectGatewayShape;
  onClientChange: (clientId: McpClientId) => void;
  onConfigCopy: (clientId: McpClientId, format: ConfigFormat) => void;
  onDeepLinkClick: (clientId: McpClientId, gatewaySlug: string) => void;
  userId: string | undefined;
};

export function ConnectSectionBody({
  gateway,
  clientForNav,
  enginePublicUrl,
  userId,
  onClientChange,
  onConfigCopy,
  onDeepLinkClick,
}: ConnectSectionBodyProps): JSX.Element {
  return (
    <section
      className="flex flex-col gap-4 pb-6"
      id="onboarding-connect-config"
    >
      <p className="text-muted-foreground text-sm leading-relaxed">
        Connect your new MCP gateway to the AI tools you use every day.
      </p>
      <ClientConnectPicker
        enginePublicUrl={enginePublicUrl}
        gateway={gateway}
        onClientChange={onClientChange}
        onConfigCopy={onConfigCopy}
        onDeepLinkClick={onDeepLinkClick}
        selectedClientId={clientForNav}
        userId={userId}
      />
    </section>
  );
}
